<template>
  <!-- eslint-disable max-len -->
  <main class="bg-white u-container">
    <p class="mb-4">
      <strong>An error has occurred while processing your Change‑of‑Address request.</strong>
    </p>
    <p class="mb-4">
      An error occurred while processing your Change-of-Address. Your Change-of-Address is NOT complete, but payment was accepted. We have automatically requested a refund on your behalf, but this process may take up to 3 business days.
    </p>
    <p class="mb-4">
      Please click "Start Over" to try again to process a Change-of-Address request.
    </p>
    <router-link
      ref="startOver"
      :to="{ name: 'disclaimer' }"
      class="c-btn"
    >
      Start Over
    </router-link>
  </main>
</template>

<script>
import Cookies from 'js-cookie';
import pageView from '../mixins/pageView';

export default {
  name: 'ErrorProcessingError',
  mixins: [pageView],
  data() {
    return {
      unloadHandle: null,
    };
  },
  mounted() {
    this.unloadHandle = window.addEventListener('unload', () => {
      Cookies.remove('coa');
      localStorage.removeItem('ampersend_data');
    });

    this.pageView();
  },
  beforeRouteLeave(to, from, next) {
    window.removeEventListener('unload', this.unloadHandle);

    if (to.name === 'disclaimer') {
      this.$coa.reset();
      Cookies.remove('coa');
      localStorage.removeItem('ampersend_data');
    }

    next();
  },
};
</script>
